function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "svg-3135443297-a",
  d: "M13.919 26.88c8.301 0 12.841-6.88 12.841-12.843 0-.195-.004-.39-.013-.583A9.182 9.182 0 0 0 29 11.117a9.022 9.022 0 0 1-2.592.71 4.53 4.53 0 0 0 1.985-2.496 9.044 9.044 0 0 1-2.866 1.095 4.515 4.515 0 0 0-7.692 4.116A12.814 12.814 0 0 1 8.53 9.828a4.498 4.498 0 0 0-.611 2.268 4.51 4.51 0 0 0 2.009 3.757 4.48 4.48 0 0 1-2.045-.564v.057a4.516 4.516 0 0 0 3.62 4.425 4.527 4.527 0 0 1-2.038.078 4.519 4.519 0 0 0 4.217 3.135 9.057 9.057 0 0 1-5.606 1.932A9.18 9.18 0 0 1 7 24.852a12.778 12.778 0 0 0 6.919 2.028"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd",
  transform: "translate(-6 -6)"
}, React.createElement("mask", {
  id: "svg-3135443297-b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#svg-3135443297-a"
})), React.createElement("g", {
  mask: "url(#svg-3135443297-b)"
}, React.createElement("path", {
  d: "M6 6h32v32H6z"
})));

var SvgTwitter = function SvgTwitter(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default SvgTwitter;